import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import junlogo from '../assets/images/gold.png';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const langButtonClass = "text-white bg-[#dcbc5c] px-3 py-1 rounded-full text-sm sm:text-base";

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.getElementById('topnav');
      if (window.scrollY > 50) {
        navbar?.classList.add('nav-sticky');
      } else {
        navbar?.classList.remove('nav-sticky');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);

  const changeLanguage = () => {
    const newLang = i18n.language === 'en' ? 'tr' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <nav id="topnav" className="w-full fixed top-0 z-50 transition-all duration-300 bg-[#1f1f2c]" aria-label="Main Navigation">
      <div className="container mx-auto px-4 flex items-center justify-between h-20">
        <div className="flex-shrink-0 min-w-[100px]">
          <Link to="/" className="flex items-center" aria-label={t('home')}>
            <img src={junlogo} alt="Jun Logo" className="h-10 sm:h-12 lg:h-12 w-auto" />
          </Link>
        </div>

        <div className="flex-grow hidden sm:block" />

        {/* Mobil Menü Butonları */}
        <div className="flex items-center justify-end space-x-4 sm:hidden">
          <button 
            className={langButtonClass} 
            onClick={changeLanguage}
            aria-label={i18n.language === 'en' ? 'Change language to Turkish' : 'Change language to English'}
          >
            {i18n.language === 'en' ? 'TR' : 'EN'}
          </button>

          <button
            className="flex flex-col space-y-1 text-white"
            onClick={toggleMenu}
            aria-label={isOpen ? 'Close mobile menu' : 'Open mobile menu'}
            aria-expanded={isOpen}
          >
            <span className={`w-6 h-0.5 bg-white transition-transform duration-300 ${isOpen ? 'rotate-45 absolute' : ''}`} />
            <span className={`w-6 h-0.5 bg-white transition-opacity duration-300 ${isOpen ? 'opacity-0' : ''}`} />
            <span className={`w-6 h-0.5 bg-white transition-transform duration-300 ${isOpen ? '-rotate-45 absolute' : ''}`} />
          </button>
        </div>

        {/* Masaüstü Menü */}
        <ul className="hidden sm:flex space-x-6 items-center">
          <li className="relative group">
            <Link to="/" className="text-white text-lg" aria-label={t('home')}>
              {t('home')}
            </Link>
            <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#dcbc5c] scale-x-0 group-hover:scale-x-100 transition-all duration-300" />
          </li>
          <li className="relative group">
            <Link to="/about" className="text-white text-lg" aria-label={t('about')}>
              {t('about')}
            </Link>
            <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#dcbc5c] scale-x-0 group-hover:scale-x-100 transition-all duration-300" />
          </li>
          <li className="relative group">
            <Link to="/contact" className="text-white text-lg" aria-label={t('contact')}>
              {t('contact')}
            </Link>
            <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#dcbc5c] scale-x-0 group-hover:scale-x-100 transition-all duration-300" />
          </li>
          <li>
            <button
              className={langButtonClass} 
              onClick={changeLanguage} 
              aria-label={i18n.language === 'en' ? 'Change language to Turkish' : 'Change language to English'}
            >
              {i18n.language === 'en' ? 'TR' : 'EN'}
            </button>
          </li>
        </ul>
      </div>

      {/* Mobil Menü Açılır Panel */}
      <div
        className={`${isOpen ? 'block' : 'hidden'} sm:hidden fixed top-0 left-0 w-full h-full bg-[#1f1f2c] z-50 transition-all duration-500 ease-in-out backdrop-blur-lg bg-opacity-40`}
        style={{
          background: 'linear-gradient(135deg, rgba(31, 31, 44, 0.8), rgba(0, 0, 0, 0.6))',
        }}
        aria-hidden={!isOpen}
      >
        <div className="absolute top-5 right-5 text-white text-3xl" onClick={toggleMenu} aria-label="Close mobile menu">
          &times;
        </div>
        <ul className="flex flex-col items-center justify-center h-full space-y-6">
          <li className="relative group">
            <Link 
              to="/" 
              className="text-white text-xl" 
              onClick={() => setIsOpen(false)} 
              aria-label={t('home')}
            >
              {t('home')}
            </Link>
          </li>
          <li className="relative group">
            <Link 
              to="/about" 
              className="text-white text-xl" 
              onClick={() => setIsOpen(false)} 
              aria-label={t('about')}
            >
              {t('about')}
            </Link>
          </li>
          <li className="relative group">
            <Link 
              to="/contact" 
              className="text-white text-xl" 
              onClick={() => setIsOpen(false)} 
              aria-label={t('contact')}
            >
              {t('contact')}
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
